/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartridgeQueryLastBookingQueryVariables = {|
  spaceRef: string,
  userRef: string,
  lang?: ?string,
|};
export type cartridgeQueryLastBookingQueryResponse = {|
  +space: ?{|
    +ref: string,
    +lastBookingByUser: ?{|
      +ref: string,
      +frontURL: ?string,
    |},
  |}
|};
export type cartridgeQueryLastBookingQuery = {|
  variables: cartridgeQueryLastBookingQueryVariables,
  response: cartridgeQueryLastBookingQueryResponse,
|};
*/


/*
query cartridgeQueryLastBookingQuery(
  $spaceRef: String!
  $userRef: String!
  $lang: String
) {
  space: getSpaceByRef(ref: $spaceRef) {
    ref
    lastBookingByUser(userRef: $userRef) {
      ref
      frontURL(lang: $lang)
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceRef"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userRef"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ref",
    "variableName": "spaceRef"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ref",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "userRef",
    "variableName": "userRef"
  }
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "lang",
      "variableName": "lang"
    }
  ],
  "kind": "ScalarField",
  "name": "frontURL",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cartridgeQueryLastBookingQuery",
    "selections": [
      {
        "alias": "space",
        "args": (v3/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "lastBookingByUser",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "cartridgeQueryLastBookingQuery",
    "selections": [
      {
        "alias": "space",
        "args": (v3/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "lastBookingByUser",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6fac43ab79b222998518774cafeae01",
    "id": null,
    "metadata": {},
    "name": "cartridgeQueryLastBookingQuery",
    "operationKind": "query",
    "text": "query cartridgeQueryLastBookingQuery(\n  $spaceRef: String!\n  $userRef: String!\n  $lang: String\n) {\n  space: getSpaceByRef(ref: $spaceRef) {\n    ref\n    lastBookingByUser(userRef: $userRef) {\n      ref\n      frontURL(lang: $lang)\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec1e58a8f6d203cad90a96f28a3cd6a7';

module.exports = node;
